import { useContext, useRef, useState } from 'react'
import Button from '../../../common/Button'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import TextArea from '../../../common/TextArea'
import InputText from '../../../common/InputText'
import { Menu } from '@styled-icons/boxicons-regular/Menu'
import { Trash, MinusSquare } from '@styled-icons/boxicons-solid'
import { useParams } from 'react-router-dom'
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from '../../../../services/base'
import { NavContext } from '../../../../context/global_context'
import { isJson } from '../../../../utils/json'
import NoRecordsFound from '../../../common/NoRecordsFound'
import Tooltip from '../../../common/tooltip'
import { downloadFileBlob, formatEmptyValue } from '../../../../utils/common'

const DemoPayload = () => {
  const { vehicle } = useParams()

  const [showDemoPayloadModal, setShowDemoPayloadModal] = useState(false)
  const [navState, navDispatch] = useContext(NavContext)

  const [searchValue, setSearchValue] = useState(null)
  const [data, setData] = useState([])
  const [selectedPayload, setSelectedPayload] = useState({})
  const [selectedPayloadName, setSelectedPayloadName] = useState(null)
  const [selectedPayloadId, setSelectedPayloadId] = useState(null)
  const demoListUrl = `/api/vehicle_demo_json/?vehicle=${vehicle}`
  const nextUrl = useRef(demoListUrl)

  const getPayloadData = async (isSearch = false) => {
    if (nextUrl.current || isSearch) {
      let res = await getRequest(
        nextUrl.current ? nextUrl.current : demoListUrl
      )
      nextUrl.current = res?.pagination?.nextPageLink
      if (!isSearch) {
        let tempRes = [...data]
        setData(tempRes.concat([...res?.results]))
      } else {
        setData(res?.results)
      }
    }
  }

  const saveDemoPayload = async (e) => {
    e.preventDefault()
    if (
      isJson(
        typeof selectedPayload === 'object'
          ? JSON.stringify(selectedPayload)
          : selectedPayload
      )
    ) {
      if (
        window.confirm(
          `${selectedPayloadId ? 'This will update selected row , ' : ''} Are you sure want to save`
        ) === true
      ) {
        navDispatch({
          type: 'loader',
          data: {
            caption: 'Saving Demo Payload',
            showLoader: true,
          },
          notification: {},
        })

        let payloadData = JSON.parse(
          typeof selectedPayload === 'object'
            ? JSON.stringify(selectedPayload)
            : selectedPayload
        )
        let formData = new FormData()
        formData.append('name', selectedPayloadName)
        formData.append('data', JSON.stringify(payloadData))
        formData.append('vehicle', vehicle)
        if (selectedPayloadId) {
          let res = await putRequest(
            `/api/vehicle_demo_json/${selectedPayloadId}/?vehicle=${vehicle}`,
            formData
          )

          nextUrl.current = `/api/vehicle_demo_json/?vehicle=${vehicle}&search=${searchValue ? searchValue : ''}`

          if (res?.status) {
            navDispatch({
              type: 'notification',
              data: {
                notification_type: 'success',
                msg: 'Demo Payload Successfully Saved',
              },
            })
            resetPayloadData()
            getPayloadData(true)
          } else {
            navDispatch({
              type: 'notification',
              data: {
                notification_type: 'error',
                msg: 'Something went wrong',
              },
            })
          }
        } else {
          let res = await postRequest(`/api/vehicle_demo_json/`, formData)
          nextUrl.current = `/api/vehicle_demo_json/?vehicle=${vehicle}&search=${searchValue ? searchValue : ''}`
          if (res?.status) {
            navDispatch({
              type: 'notification',
              data: {
                notification_type: 'success',
                msg: 'Demo Payload Successfully Saved',
              },
            })
            resetPayloadData()
            getPayloadData(true)
          } else {
            navDispatch({
              type: 'notification',
              data: {
                notification_type: 'error',
                msg: 'Something went wrong',
              },
            })
          }
        }
      }
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: 'Please Enter Valid Json',
        },
      })
    }
  }

  const deleteSelectedPayload = async (id, name) => {
    if (
      window.confirm(`Are you sure want to delete selected ${name}`) === true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: `Deleting payload ${name}`,
          showLoader: true,
        },
        notification: {},
      })

      let res = await deleteRequest(
        `/api/vehicle_demo_json/${id}/?vehicle=${vehicle}`
      )

      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Deleted Successfully',
          },
        })
        getPayloadData(true)
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: 'Something went wrong',
          },
        })
      }
    }
  }

  const resetPayloadData = (resRow) => {
    setSelectedPayload(resRow?.data)
    setSelectedPayloadId(resRow?.id)
    setSelectedPayloadName(resRow?.name)
  }

  const downloadZip = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Downloading All Json files.',
        showLoader: true,
      },
      notification: {},
    })

    let res = await postRequest(
      `/api/vehicle_demo_json/download/${vehicle}/`,
      true,
      true
    )
    if (res?.msg) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(new Blob([res]), `${vehicle}-demo.zip`)
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Successfully Downloaded.',
        },
      })
    }
  }

  return (
    <>
      <Button
        className={`cursor-pointer btn w-full justify-end`}
        onClick={(e) => {
          setShowDemoPayloadModal(true)
          getPayloadData()
        }}
        value={'text'}
        text="Demo Payload"
      />

      <Modal
        onClose={() => {
          setShowDemoPayloadModal(false)
        }}
        show={showDemoPayloadModal}
        size={'w-3/4'}
      >
        <ModalHeader className={'text-white p-1'}>
          <div className="flex text-sm items-center justify-between">
            <div>Demo Payload</div>
            {data?.length > 0 && (
              <div className="px-3">
                <Button
                  className={`cursor-pointer btn my-1 justify-end ml-2`}
                  text={`Download`}
                  onClick={(e) => {
                    downloadZip()
                  }}
                />
              </div>
            )}
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="flex justify-between text-sm font-normal">
            <div className="w-1/2">
              <form
                onSubmit={(e) => {
                  saveDemoPayload(e)
                }}
                name="demo-payload"
                className=""
              >
                <input type="hidden" value={vehicle} name="vehicle" />
                <TextArea
                  name="data"
                  value={
                    typeof selectedPayload === 'object'
                      ? JSON.stringify(selectedPayload)
                      : selectedPayload
                  }
                  onChange={(e) => {
                    setSelectedPayload(e)
                  }}
                  wrapperClass="p-0"
                  isRequired={true}
                  placeholder={`Payload Json`}
                  className="h-50vh"
                  isDefaultValue={true}
                  key={`data-${selectedPayloadId}`}
                  label={`Payload Json`}
                />
                <div className="flex justify-end py-3">
                  <InputText
                    name="name"
                    placeholder={`Enter Payload Name...`}
                    className={`w-100`}
                    value={selectedPayloadName}
                    isFullSize={true}
                    type="text"
                    onChange={(value) => {
                      setSelectedPayloadName(value)
                    }}
                    isRequired={true}
                    wrapperClass={`pl-0`}
                    isDefaultValue={true}
                    key={`name-${selectedPayloadId}`}
                  />
                  <Button
                    className={`cursor-pointer btn my-1 justify-end ml-2`}
                    text={`Save Payload`}
                    onClick={(e) => {}}
                  />
                </div>
              </form>
            </div>
            <div className="w-1/2">
              {data?.length > 0 ? (
                <>
                  <div className="px-3">
                    <InputText
                      name="name"
                      placeholder={`Enter To Search Payload...`}
                      className={`w-100`}
                      value={searchValue}
                      isFullSize={true}
                      type="search"
                      onChange={(value) => {
                        setSearchValue(value)
                        nextUrl.current = `/api/vehicle_demo_json/?vehicle=${vehicle}&search=${value}`
                        getPayloadData(true)
                      }}
                      isRequired={true}
                      wrapperClass={`pl-0`}
                    />
                  </div>

                  <div
                    className="py-2 px-3"
                    style={{ maxHeight: '50vh', overflowY: 'auto' }}
                  >
                    {data?.map((resRow, resIdx) => {
                      return (
                        <div
                          key={`res-${resIdx}`}
                          className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black"
                        >
                          <div className="flex flex-row w-full">
                            <div className="w-10/12 text-xl table_text">
                              <Tooltip message={resRow.name}>
                                <div>{formatEmptyValue(resRow.name)}</div>
                              </Tooltip>
                            </div>
                            <div className="w-2/12 flex justify-end">
                              {selectedPayloadId == resRow.id ? (
                                <MinusSquare
                                  className="cursor-pointer"
                                  size="1.5rem"
                                  color="green"
                                  onClick={() => {
                                    resetPayloadData()
                                  }}
                                />
                              ) : (
                                <Menu
                                  className="cursor-pointer"
                                  size="1.5rem"
                                  color="gray"
                                  onClick={() => {
                                    resetPayloadData(resRow)
                                  }}
                                />
                              )}

                              <Trash
                                className="cursor-pointer text-red-600"
                                size="1.5rem"
                                color="gray"
                                onClick={() => {
                                  deleteSelectedPayload(resRow.id, resRow.name)
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                  {nextUrl.current && (
                    <div className="flex justify-end px-3">
                      <span
                        className="underline cursor-pointer"
                        onClick={() => {
                          getPayloadData()
                        }}
                      >
                        Load More
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <div className="px-3">
                  <NoRecordsFound />
                </div>
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default DemoPayload
